import { DateType } from 'module/types/common';
import { Company } from '../company/types';
import { UserProfileInfo, UserMeta } from '../user/types';

export enum IdpType {
  Google = 'GOOGLE',
  Saml = 'SAML',
}

export enum AuthenticationServiceProvider {
  COGNITO = 'COGNITO',
  OKTA = 'OKTA',
}

export interface Idp {
  idpId: string;
  idpType: IdpType;
  enabled: boolean;
}

export interface OktaMetaData {
  clientId: string;
  issuerDomain: string;
  userName?: string;
  idps?: Idp[];
  authenticationServiceProvider: AuthenticationServiceProvider;
  customAuthentication: boolean;
}

export interface Currency {
  currencyName: string;
  currencyCode: string;
  currencySymbol: string;
}

export interface AccountMeta {
  company: Company;
  okta: OktaMetaData;
  features: {
    timesheets: boolean;
    financials: boolean;
    invoices: boolean;
    disablePoweredBy: boolean;
    disableCustomerSlackConnect: boolean;
    hippaCompliance: boolean;
    bulkPlaceHolderUpdate: boolean;
    aiFills: boolean;
    clickhouse: boolean;
    knowledgeBase: boolean;
  };
}

export type ForgotAccountPayload = {
  email: string;
};
interface Session {
  sessionToken: string;
  //FIXME: add right type here
  sessionUser: any;
}
export enum AccountStatus {
  Trial = 'TRIAL',
  Active = 'ACTIVE',
  Grace = 'GRACE',
  Suspended = 'SUSPENDED',
  Paid = 'PAID',
}

export enum WarningErrorCode {
  PaymentFailed = 'PAYMENT_FAILED',
}

export enum WarningType {
  Billing = 'BILLING',
}

export type Warning = {
  errorCode: WarningErrorCode;
  warningType: WarningType;
};
export enum ProductType {
  Signals = 'SIGNALS',
  Rocketlane = 'ROCKETLANE',
}
export interface Account {
  accountName: string;
  accountId: number;
  company: Company;
  //FIXME: add right type here
  metaData: Partial<any>;
  primaryDomainName: string;
  defaultDomainName: string;
  expiryDate: string | null; // YYYY-MM-DD
  status: AccountStatus;
  timeZone: string;
  systemBotId: number;
  accountWarnings?: Warning[];
  createdAt: string | null;
}
export interface AccountSignUpResponse {
  session: Session;
  account: Account;
  templateId: number;
}
export interface AccountSignUpPayload {
  emailId: string;
  companyName: string;
  domainName: string;
  firstName: string;
  lastName: string;
  newPassword: string;
  token: string;
  contactNumber: string;
  timeZone: string;
}

export interface AccountSignUpThroughGooglePayload {
  emailId: string;
  companyName: string;
  domainName: string;
  firstName: string;
  lastName: string;
  newPassword: string;
  contactNumber: string;
  timeZone: string;
  signUpHandlerType: string;
  credential: string;
  productType: ProductType;
}
export type IsDomainExistsPayload = {
  domainName: string;
  token: string;
  throughGoogleAuth: boolean;
};
export interface IsDomainExistsResponse extends IsDomainExistsPayload {
  domainExists: boolean;
}

export type CurrencyList = Currency[];

export interface CurrencyMapping {
  accountCurrencyMappingId: number;
  currency: Currency;
  exchangeRate: number;
  defaultCurrency: boolean;
  enabled: boolean;
  activeDefaultCurrency?: Currency;
  updatedAt?: DateType;
  updatedBy?: number;
  createdAt?: DateType;
  createdBy?: number;
  backdatedTo?: DateType;
}

export type CurrencyMappingList = CurrencyMapping[];
export interface AccountInitialData {
  accountMeta: AccountMeta;
  account: Account;
  companies: Company[];
  userProfile: UserProfileInfo;
  userMeta: UserMeta;
}
